import { ElementConfigName } from '@editor2/types/pageElements';
import { isDoubleElement } from './elementService';

export const validatePageReorder = (sourceIndex, destinationIndex, items) => {
	const previousPageIndex = items
		.slice(0, sourceIndex)
		.reverse()
		.findIndex((el) => el.type === 'NG::Traditional::Page');
	const nextPageIndex = items
		.slice(sourceIndex + 1)
		.findIndex((el) => el.type === 'NG::Traditional::Page');

	if (
		destinationIndex <= sourceIndex - previousPageIndex - 1 ||
		(nextPageIndex > -1 && destinationIndex > nextPageIndex + sourceIndex)
	) {
		throw new Error('Rejected: Pages reorder is not allowed here.');
	}
};

export const validatePageInsideDoubleElement = (sourceIndex, destinationIndex, destinationItem) => {
	switch (true) {
		case sourceIndex > destinationIndex:
			if (
				destinationItem.indent ||
				(isDoubleElement(destinationItem.type) && destinationItem.direction === 'out')
			) {
				throw new Error('Rejected: Split Double element is not allowed');
			}
			break;
		case sourceIndex < destinationIndex:
			if (
				destinationItem.indent ||
				(isDoubleElement(destinationItem.type) && destinationItem.direction === 'in')
			) {
				throw new Error('Rejected: Split Double element is not allowed');
			}
			break;
	}
};

export const validateSplitDoubleElement = (
	draggableElement,
	sourceIndex,
	destinationIndex,
	items
) => {
	const elementName = ElementConfigName[draggableElement.type];
	const errorMessage = `Rejected: Move ${elementName} to another page is not allowed.`;

	switch (draggableElement.direction) {
		case 'in': {
			const sliceBefore = items.slice(0, sourceIndex).reverse();
			const pageIndexBefore = sliceBefore.findIndex((el) => el.type === 'NG::Traditional::Page');

			if (pageIndexBefore >= 0 && destinationIndex < sourceIndex - pageIndexBefore) {
				throw new Error(errorMessage);
			}
			break;
		}

		case 'out': {
			const sliceAfter = items.slice(sourceIndex);
			const pageIndexAfter = sliceAfter.findIndex((el) => el.type === 'NG::Traditional::Page');

			if (pageIndexAfter >= 0 && destinationIndex >= sourceIndex + pageIndexAfter) {
				throw new Error(errorMessage);
			}
			break;
		}

		default:
			break;
	}
};
